export const p2e = (str) => {
    if (!str) return '';
    return str.replace(/[۰-۹]/g, function (w) {
        return String.fromCharCode(w.charCodeAt(0) - 1728);
    });
}

export const e2p = (str) => {
    if (!str) return '';
    return str.replace(/\d/g, function (d) {
        return String.fromCharCode(d.charCodeAt(0) + 1728);
    });
}

export const formatNumber = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const Wordify = (number) => {
    if (number === 0) {
        return 'صفر';
    }
    if (number < 0) {
        return 'منفی ' + Wordify(-number);
    }
    if (number <= 19) {
        return ['یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه', 'ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'][number - 1];
    }
    if (number <= 99) {
        return ['بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'][Math.floor(number / 10) - 2] + (number % 10 ? ' و ' + Wordify(number % 10) : '');
    }
    if (number <= 999) {
        return Wordify(Math.floor(number / 100)) + ' صد' + (number % 100 ? ' و ' + Wordify(number % 100) : '');
    }
    if (number <= 999999) {
        return Wordify(Math.floor(number / 1000)) + ' هزار' + (number % 1000 ? ' و ' + Wordify(number % 1000) : '');
    }
    if (number <= 999999999) {
        return Wordify(Math.floor(number / 1000000)) + ' میلیون' + (number % 1000000 ? ' و ' + Wordify(number % 1000000) : '');
    }
    return Wordify(Math.floor(number / 1000000000)) + ' میلیارد' + (number % 1000000000 ? ' و ' + Wordify(number % 1000000000) : '');
}


export const getRoleTitle = (role) => {
    switch (role) {
        case 'admin':
            return 'ادمین';
        case 'company':
            return 'مسئول صافکاری';
        case 'factory':
            return 'مسئول شعبه';
        case 'normal':
            return 'کاربر عادی';
    }
}
